module.exports = __webpack_public_path__ + "ec1f8d7a6560777a47f95447a59b88c6.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_war_has_a_price_H1050px.png
// module id = 402
// module chunks = 0